<template>
  <div class="box">
    <LoopScroll :dataSource="phone_list" direction="left"></LoopScroll>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { LoopScroll } from '@joyday/vue-loop-scroll'

@Options({
  props: {},
  components: {
    LoopScroll
  },
  data () {
    return {
      phone_list: [
        '138****2512 抢到了 ',
        '137****5287 抢到了 ',
        '136****7818 抢到了 ',
        '182****9894 抢到了 ',
        '137****5471 抢到了 ',
        '138****2512 抢到了 ',
        '137****5287 抢到了 ',
        '136****7818 抢到了 ',
        '182****9894 抢到了 ',
        '137****5471 抢到了 ',
      ]
    }
  }
})
export default class RowScollView extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.box {
  width: 100%;
  color:white;
  font-size: 24px;
  :deep(.scroll-loop-item) {
    padding: 20px;
    background: #00000066;
    margin-left: 20px;
    border-radius: 30px;
  }
}
</style>
